<template>
    <v-dialog v-model="$store.getters.loading" fullscreen full-width>
        <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5); padding: 0;">
            <v-layout>
                <v-progress-linear style="margin: 0; background-color: rgb(178, 150, 227)"
                    :active=true
                    :background-opacity=0.3
                    :bottom=false
                    :buffer-value=0
                    :height=4
                    :indeterminate=true
                    :absolute=true
                    :query=false
                    :rounded=false
                    :stream=false
                    :striped=false
                    :top=false
                    :value=25
                    color="primary">
                </v-progress-linear>
            </v-layout>
        </v-container>
    </v-dialog>
</template>

<script>
export default {
  name: "linear",
  data() {
    return {
      mutableLoading: this.loading
    };
  }
};
</script>
